import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Button } from 'ui-components/components/button';
import { ModalFooter } from 'ui-components/components/modal/modal-footer';
import { ModalFooterCancelButton } from 'ui-components/components/modal/modal-footer/cancel-button';
import { FlexRow } from 'ui-components/components/flex';

import { BulkApplyCheckbox } from '../../../../../../../fulfillment-plans/bulk-apply/bulk-apply-checkbox';
import { useEditShipToFormContext } from './context';

import messages from '../messages';
import style from './edit-shipto-modal.module.less';

const EditShipToModalFooter = ({ onClose }) => {
  const { isValid, save, isSaving, isBulkUpdate, setIsBulkUpdate, isOrderOverview } = useEditShipToFormContext();

  const toggleBulkUpdate = useCallback(() => {
    setIsBulkUpdate((prev) => !prev);
  }, [setIsBulkUpdate]);

  const onSave = useCallback(async () => {
    const didSucceed = await save();
    if (didSucceed) {
      onClose();
    }
  }, [save, onClose]);

  return (
    <ModalFooter className={style['edit-address-footer']}>
      <FlexRow className={style['edit-address-footer-buttons']}>
        <BulkApplyCheckbox disabled={isOrderOverview} isBulkUpdate={isBulkUpdate} toggleBulkUpdate={toggleBulkUpdate} />
        <div className={style['edit-address-footer-right-side']}>
          <ModalFooterCancelButton />
          <Button disabled={!isValid || isSaving} onClick={onSave} theme='primary'>
            {isOrderOverview ? <FormattedMessage {...messages.saveButtonApplyToAll} /> : <FormattedMessage {...messages.saveButton} />}
          </Button>
        </div>
      </FlexRow>
    </ModalFooter>
  );
};

EditShipToModalFooter.propTypes = {
  onClose: PropTypes.func.isRequired,
};

export default EditShipToModalFooter;
